import { createContext, useContext } from 'react'

import type { PaytrieAPI } from '@paytrie/client'

type AuthContextType = {
  loading: boolean
  isAuth: boolean
  authError: boolean
  user: PaytrieAPI.CurrentUser | null
}

const initialState: AuthContextType = {
  loading: true,
  isAuth: false,
  authError: false,
  user: null,
}

export const AuthContext = createContext<AuthContextType>(initialState)

export const useAuth = () => {
  return useContext(AuthContext)
}
